import { Component, Input, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';

import { ApiError, BaseFormList, MessageService } from '../../../core';

import { RegiaoRepresentante } from './regiao-representante';
import { Representante, TypeaheadRepresentanteComponent } from '../../pessoa/representante';
import { RegiaoRepresentantePopulaModalComponent } from './popula-modal';

@Component({
    selector: 'sgt-regiao-representante',
    templateUrl: './regiao-representante.component.html',
    styleUrls: ['./regiao-representante.component.less']
})
export class RegiaoRepresentanteComponent implements BaseFormList<RegiaoRepresentante>, OnInit {
    @Input() entities: RegiaoRepresentante[];

    @ViewChild('regiaoRepresentantePopulaModal') regiaoRepresentantePopulaModal: RegiaoRepresentantePopulaModalComponent;
    @ViewChildren('typeaheadRepresentante') typeaheadsRepresentantes: QueryList<TypeaheadRepresentanteComponent>;

    constructor(private messageService: MessageService) { }

    ngOnInit() {
    }

    /** Ao alterar o representante no typeahead */
    onChangeRepresentante(entity: RegiaoRepresentante, representante: Representante) {
        if (representante) {
            entity.idRepresentante = representante.id;
        } else {
            entity.idRepresentante = null;
        }
    }

    insert() {
        const entity = new RegiaoRepresentante();
        this.entities.push(entity);

        setTimeout(() => this.setFocusInsertRepresentante(), 200);
    }

    /** Seta o foco no typeahead do representante ao inserir um novo representante */
    private setFocusInsertRepresentante() {
        if (!this.typeaheadsRepresentantes) {
            return;
        }
        // Obtendo o último typeahead para setar o foco
        const typeaheadRepresentante = this.typeaheadsRepresentantes.last;
        if (typeaheadRepresentante) {
            typeaheadRepresentante.setFocus();
        }
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir esse representante?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os representantes da região estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];

            if (!entity.idRepresentante) {
                this.messageService.info('É necessário informar o representante ou excluir esse representante', 'Informação');
                return false;
            }


            const count = this.entities.filter(entityFilter => entityFilter.idRepresentante && entityFilter.idRepresentante === entity.idRepresentante).length;
            if (count > 1) {
                this.messageService.info(`O representante ${entity.representante.pessoa.nome} já está adicionado. Remova ou altere o representante duplicado`, 'Não é possível adicionar dois representantes iguais');
                return false;
            }
        }

        return true;
    }

    /** Resolve os representantes presentes na região */
    resolve() { }

    /** Abre o modal para adicionar os representantes na região */
    openPopulaCidadeModal() {
        this.regiaoRepresentantePopulaModal.open();
    }
}
